var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgDetection = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 81 81",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M40.212.001 40.5 0C62.867 0 81 18.133 81 40.5S62.867 81 40.5 81 0 62.867 0 40.5C0 18.768 17.116 1.034 38.603.044A22.334 22.334 0 0 1 40.213 0Zm-21.485 16.37C12.14 22.32 8 30.927 8 40.5 8 58.45 22.55 73 40.5 73S73 58.45 73 40.5c0-10.205-4.704-19.312-12.061-25.27A21.984 21.984 0 0 1 62 22c0 12.15-9.85 22-22 22s-22-9.85-22-22c0-1.945.253-3.832.727-5.628Zm20.321-8.34a33.04 33.04 0 0 1 1.15-.03C47.838 8.107 54 14.334 54 22c0 7.732-6.268 14-14 14s-14-6.268-14-14c0-7.412 5.76-13.479 13.048-13.968Z",
  fill: "#139757"
})));

export default SvgDetection;